export const MERCHANT = "MERCHANT";
export const MERCHANT_THEME = "MERCHANT_THEME";
export const LOYALTY_USER = "LOYALTY_USER";
export const AUTHENTICATED_USER = "AUTHENTICATED_USER";
